export default "assets/images/flags/it-b222f037.svg";